import $ from 'jquery';
import { dependency } from '../../utils/request';

const recaptchaPath = 'https://www.google.com/recaptcha/api.js';

/**
 * Enhances forms with Google reCAPTCHA functionality.
 * Requires use of the reCAPTCHA Craft plugin.
 *
 * @param context
 */
export default function validatorDirective(context=document.body) {
	const $context = $(context);
	const $forms = $context.find('form[sw-recaptcha]');

	// Only load reCAPTCHA API if there are forms on the page
	if ($forms.length > 0) {
		dependency(recaptchaPath, () => {

			$forms.each(function() {
				const $form = $(this);

				const $recaptcha = $form.find('.g-recaptcha');
				const callbackName = $form.attr('sw-recaptcha');
				const formParsley = window.Parsley ? $form.parsley() : null;

				window[callbackName] = function()
				{
					// Removes all recaptcha event listeners so the recaptcha doesn't resend when resubmitting
					$recaptcha.replaceWith($recaptcha.clone());

					if (formParsley) {
						formParsley.whenValidate().then(function() {
							$form.submit();
						});
					}
				}
			});

		}, () => window.grecaptcha);
	}
}



// WEBPACK FOOTER //
// ./source/scripts/directives/form/recaptcha.js